import React, { useEffect, useState } from 'react';
import { Container, Grid, Typography, TextField, Checkbox, FormControlLabel, IconButton, InputAdornment, MenuItem, Select, InputLabel, FormControl, CircularProgress } from '@mui/material';
import CustomizedSteppers from '../../components/IndicativoFluxo';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, RadioButtonUnchecked, Visibility, VisibilityOff } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEstados, formatCEP, formatCNPJ, formatCPF, formatTelefone, isValidCEP, isValidCNPJ, isValidCPF, isValidEmail, isValidTelefone } from '../../services/utils';
import axios from 'axios';
import MapComponent from '../../components/MapComponent';
import AutocompleteMap from '../../components/AutocompleteMap/AutocompleteMap';
import ButtonPick from '../../components/ButtonPick/ButtonPick';
import ButtonReturn from '../../components/ButtonReturn/ButtonReturn';
import { fetchCnpjStart, salvarDadosAction, loadingAutocompleteCnpjTrue, loadingAutocompleteCnpjFalse, limparDadosEnvioPagamento, limparAssinaturaTransacaoIDAction } from '../../store/reducers/utils';

function Cadastro() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const cnpjDados = useSelector((state) => state.utils.cnpjDados);
    const planoSelecionado = useSelector(state => state.plano.planoSelecionado);
    const dadosCadastro = useSelector(state => state.utils.dadosCadastro);
    const [semNumero, setSemNumero] = useState(false);
    const [usarMesmoEmail, setUsarMesmoEmail] = useState(false);
    const [formState, setFormState] = useState({
        emailPessoal: '',
        nome: '',
        cpf: '',
        telefone: '',
        emailAcesso: '',
        senha: '',
        confirmarSenha: '',
        razaoSocial: '',
        cnpj: '',
        endereco: '',
        cep: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        latitude: '',
        longitude: '',
        pontoReferencia: '',
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [estados, setEstados] = useState([]);
    const [arrayCidades, setArrayCidades] = useState([]);
    const [cidadePesquisa, setCidadePesquisa] = useState('');
    const [position, setPosition] = useState({
        latitude: -15.7797200,
        longitude: -47.9297200
    })
    const [prosseguir, setProsseguir] = useState(false);
    const loadingAutocompleteCnpj = useSelector(state => state.utils.loadingAutocompleteCnpj);
    const dadosAntigo = useSelector(state => state.plano?.dadosUsuario?.dados);

    useEffect(() => {
        if (dadosAntigo) {
            navigate('/pagamento');
        }
    }, [dadosAntigo])

    // Utils functions
    const handleFormState = (e) => {
        const { name, value } = e.target;
        setFormState({
            ...formState,
            [name]: value,
        });
    };

    const handleBlur = (e) => {
        const { name } = e.target;
        setFormState({
            ...formState,
            [`${name}Tocado`]: true,
        });
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleClickShowPasswordConfirm = () => {
        setShowPasswordConfirm(!showPasswordConfirm);
    };

    const handleMouseDownPasswordConfirm = (event) => {
        event.preventDefault();
    };

    function limparCNPJ(cnpj) {
        return cnpj.replace(/\D/g, '');
    }

    const handleSemNumeroChange = (event) => {
        setSemNumero(event.target.checked);
        setFormState(prevState => ({ ...prevState, numero: 'S/N' }));
    };

    useEffect(() => {
        if (usarMesmoEmail) {
            setFormState(prevState => ({
                ...prevState,
                emailAcesso: prevState.emailPessoal || ''
            }));
        }
    }, [usarMesmoEmail, formState.emailPessoal, setFormState]);

    const findCidadeID = (nomeCidade) => {
        const cidade = arrayCidades.find((cidade) => cidade.cidadeNome === nomeCidade)
        const cidadeID = cidade !== undefined ? cidade.cidadeID : ''
        if (!!cidadeID) {
            setFormState(prevState => ({
                ...prevState,
                cidade: cidadeID,
            }));
        }
    }

    useEffect(() => {
        if (cidadePesquisa !== '' && arrayCidades.length > 0) {
            findCidadeID(cidadePesquisa)
        }
    }, [cidadePesquisa, arrayCidades]);

    useEffect(() => {
        if (cnpjDados.sucesso) {
            setFormState({
                ...formState,
                cep: '',
                bairro: '',
                cidade: '',
                complemento: '',
                estado: '',
                razaoSocial: '',
                endereco: '',
            });

            setSemNumero(() => {
                const apenasNumeros = cnpjDados.empresa.numero.replace(/\D/g, '');
                const validation = !/\d/.test(apenasNumeros)
                validation
                    ? setFormState(prevState => ({ ...prevState, numero: 'S/N' }))
                    : setFormState(prevState => ({ ...prevState, numero: cnpjDados.empresa.numero }));
                return validation;
            })

            const estadoID = estados.find(estado => estado.estadoUF === cnpjDados.empresa.estado)?.estadoID || ''


            setFormState({
                ...formState,
                cep: cnpjDados.empresa.CEP || '',
                bairro: cnpjDados.empresa.bairro || '',
                complemento: cnpjDados.empresa.complemento || '',
                estado: estadoID,
                cidade: '',
                razaoSocial: cnpjDados.empresa.nome || '',
                endereco: cnpjDados.empresa.logradouro || '',
            });

            handleCidadesChange(estadoID);
            setCidadePesquisa(cnpjDados.empresa.cidade)
        } else if (Object.keys(cnpjDados).length > 0 && !cnpjDados.sucesso) {
            console.log("Erro: ", cnpjDados);
        }
        dispatch(loadingAutocompleteCnpjFalse());
    }, [cnpjDados, estados])

    useEffect(() => {
        if (Object.keys(cnpjDados).length > 0 && cnpjDados.sucesso) {
            setPosition({
                latitude: cnpjDados.empresa.latitude,
                longitude: cnpjDados.empresa.longitude
            })
        }
    }, [cnpjDados])

    useEffect(() => {
        let cnpjLength
        cnpjLength = (limparCNPJ(formState.cnpj).length === 14)

        if (cnpjLength) {
            dispatch(loadingAutocompleteCnpjTrue());
            const valueCNPJ = limparCNPJ(formState.cnpj);
            dispatch(fetchCnpjStart(valueCNPJ));
        }
    }, [formState.cnpj])

    useEffect(() => {
        setFormState({
            ...formState,
            latitude: position.latitude,
            longitude: position.longitude
        })
    }, [position])

    useEffect(() => {
        const getEstados = async () => {
            const estados = await fetchEstados();
            setEstados(estados);
        }
        getEstados();
        // Limpa os dados de envio de pagamento
        dispatch(limparDadosEnvioPagamento());
        dispatch(limparAssinaturaTransacaoIDAction());

        // preenche os dados do usuário caso existam na store
        if (Object.keys(dadosCadastro).length > 0) {
            const {
                usuario: { nome, cpf },
                pick: { telefoneComercial, nome: razaoSocial, cnpj, emailFinanceiro },
                endereco: { logradouro: endereco, CEP: cep, numero, complemento, bairro, cidadeID: cidade, estadoID: estado, latitude, longitude, pontoReferencia },
                emailAcesso,
                senhaAcesso
            } = dadosCadastro

            setFormState((prevState) => ({
                ...prevState,
                emailPessoal: emailAcesso || '',
                senha: senhaAcesso || '',
                confirmarSenha: senhaAcesso || '',
                nome: nome || '',
                cpf: cpf || '',
                telefone: telefoneComercial || '',
                emailAcesso: emailFinanceiro || '',
                razaoSocial: razaoSocial || '',
                cnpj: cnpj || '',
                endereco: endereco || '',
                cep: cep || '',
                numero: numero || '',
                complemento: complemento || '',
                bairro: bairro || '',
                cidade: cidade || '',
                estado: estado || '',
                latitude: latitude || '',
                longitude: longitude || '',
                pontoReferencia: pontoReferencia || ''
            }))
        }
    }, [])

    const buscarCidadesPorEstado = async (estadoID) => {
        try {
            const url = 'https://acesso.pickngo.online/api/listarcidades'
            const data = {
                Pagina: 1,
                Paginacao: -1,
                Filtros: `estadoID == ${estadoID}`,
            }
            const response = await axios.post(url, data)
            if (response.data.sucesso) {
                return response.data.dados.lista; // Retorna a lista de cidades
            } else {
                return [];
            }
        } catch (error) {
            console.error('Erro ao buscar estados:', error);
            return [];
        }
    };

    const handleCidadesChange = async (estado) => {
        if (estado) {
            const cidades = await buscarCidadesPorEstado(estado);
            setArrayCidades([]);
            setArrayCidades(cidades);
        }
    }

    const handleEstadoChange = async (event) => {
        const estadoSelecionado = event.target.value;
        setFormState((prevState) => ({
            ...prevState,
            estado: estadoSelecionado,
            cidade: '',
        }));

        handleCidadesChange(estadoSelecionado);
    };

    const handleSubmit = (event) => {
        const { bairro, cep, cnpj, estado, cidade, complemento, cpf, emailAcesso, emailPessoal, endereco, latitude, longitude, nome, numero, razaoSocial, senha, telefone, pontoReferencia } = formState;

        const dadosFinais = {
            usuario: {
                nome: nome,
                cpf: cpf,
            },
            pick: {
                telefoneComercial: telefone,
                nome: razaoSocial, // nome fantasia seria o ideal 
                cnpj: cnpj,
                emailFinanceiro: emailPessoal,
            },
            endereco: {
                logradouro: endereco,
                CEP: cep,
                numero: numero,
                complemento: complemento,
                pontoReferencia: pontoReferencia,
                bairro: bairro,
                estadoID: estado,
                cidadeID: cidade,
                latitude: latitude,
                longitude: longitude,
            },
            emailAcesso: emailAcesso,
            senhaAcesso: senha,
        };
        dispatch(salvarDadosAction(dadosFinais));
    }

    /* Erros e Validações */
    const emailPessoalError =
        (formState.emailPessoal === '' && formState.emailPessoalTocado) ||
        (formState.emailPessoal !== '' && !isValidEmail(formState.emailPessoal));

    const emailAcessoError =
        (formState.emailAcesso === '' && formState.emailAcessoTocado) ||
        (formState.emailAcesso !== '' && !isValidEmail(formState.emailAcesso));

    const nomeError =
        (formState.nome === '' && formState.nomeTocado) ||
        (formState.nome !== '' && formState.nome?.length < 3);

    const cpfError =
        (formState.cpf === '' && formState.cpfTocado) ||
        (formState.cpf !== '' && !isValidCPF(formState.cpf));

    const telefoneError =
        (formState.telefone === '' && formState.telefoneTocado) ||
        (formState.telefone !== '' && !isValidTelefone(formState.telefone));

    const senhaError =
        (formState.senha === '' && formState.senhaTocado) ||
        (formState.senha !== '' && formState.senha?.length < 6);

    const confirmarSenhaError =
        (formState.confirmarSenha === '' && formState.confirmarSenhaTocado) ||
        (formState.confirmarSenha !== '' && formState.confirmarSenha !== formState.senha);

    const razaoSocialError =
        (formState.razaoSocial === '' && formState.razaoSocialTocado) ||
        (formState.razaoSocial !== '' && formState.razaoSocial?.length < 3);

    const cnpjError =
        (formState.cnpj === '' && formState.cnpjTocado) ||
        (formState.cnpj !== '' && !isValidCNPJ(formState.cnpj) ||
            (cnpjDados.sucesso === false)
        );

    const enderecoError =
        (formState.endereco === '' && formState.enderecoTocado) ||
        (formState.endereco !== '' && formState.endereco?.length < 3);

    const numeroError =
        (formState.numero === '' && formState.numeroTocado) ||
        (formState.numero !== '' && formState.numero?.length < 1);

    const estadoError =
        (formState.estado === '' && formState.estadoTocado) ||
        (formState.estado !== '' && formState.estado?.length < 2);

    const bairroError =
        (formState.bairro === '' && formState.bairroTocado) ||
        (formState.bairro !== '' && formState.bairro?.length < 3);

    const cidadeError =
        (formState.cidade === '' && formState.cidadeTocado) ||
        (formState.cidade !== '' && formState.cidade?.length < 3);

    const cepError =
        (formState.cep === '' && formState.cepTocado) ||
        (formState.cep !== '' && !isValidCEP(formState.cep));

    // Lógica p/ Prosseguir
    useEffect(() => {
        const errors = {
            emailPessoal: emailPessoalError || formState.emailPessoal === '',
            emailAcesso: emailAcessoError || formState.emailAcesso === '',
            nome: nomeError || formState.nome === '',
            cpf: cpfError || formState.cpf === '',
            telefone: telefoneError || formState.telefone === '',
            senha: senhaError || formState.senha === '',
            confirmarSenha: confirmarSenhaError || formState.confirmarSenha === '',
            razaoSocial: razaoSocialError || formState.razaoSocial === '',
            cnpj: cnpjError || formState.cnpj === '',
            endereco: enderecoError || formState.endereco === '',
            numero: numeroError || formState.numero === '',
            estado: estadoError || formState.estado === '',
            bairro: bairroError || formState.bairro === '',
            cidade: cidadeError || formState.cidade === '',
            cep: cepError || formState.cep === '',
        }
        setProsseguir(Object.values(errors).every(error => error === false));
    }, [formState, emailPessoalError, emailAcessoError, nomeError, cpfError, telefoneError, senhaError, confirmarSenhaError, razaoSocialError, cnpjError, cnpjDados, cepError, setProsseguir]);

    // Estilização de Componentes
    const textFieldStyles = {
        '& label.Mui-focused': {
            color: '#FF9F0D',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#FF9F0D',
            },
            '&:hover fieldset': {
                borderColor: '#FF9F0D',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#FF9F0D',
            },
        },
    };

    const selectStyles = {
        width: "100%",
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#FF9F0D',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#FF9F0D',
            },
            '&:hover fieldset': {
                borderColor: '#FF9F0D',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#FF9F0D',
            },
        },
    };

    return (
        <Container maxWidth="lg" sx={{ mt: 1 }} >
            <Grid container alignItems="center" justifyContent="space-between" mb={2}>
                <Grid item>
                    <ButtonReturn text="Voltar para planos" />
                </Grid>
                <Grid item xs={12} textAlign="center">
                    <Typography variant="h4" sx={{ color: '#000', fontWeight: 'bold', mt: 2 }}>
                        {planoSelecionado?.nome?.toUpperCase() || 'PLANO'}
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#A4A4A4', mb: 2, fontWeight: 'bold', fontSize: '16px' }}>
                        Preencha todas as informações
                    </Typography>
                </Grid>
                <Grid item xs={1} sm={2}></Grid> {/* Espaço para manter o alinhamento */}
            </Grid>
            <CustomizedSteppers activeStep={1} />
            <Grid sx={{ p: 1 }}>
                <Typography variant="h5" gutterBottom >Dados Pessoais</Typography>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="Email"
                            variant="outlined"
                            fullWidth
                            name="emailPessoal"
                            value={formState.emailPessoal}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            error={emailPessoalError}
                            helperText={emailPessoalError && 'Email inválido'}
                            sx={textFieldStyles}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="Nome"
                            variant="outlined"
                            fullWidth
                            name="nome"
                            value={formState.nome}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            sx={textFieldStyles}
                            error={nomeError}
                            helperText={nomeError ? 'Nome inválido' : ''}
                            inputProps={{ maxLength: 60 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="CPF"
                            variant="outlined"
                            fullWidth
                            name="cpf"
                            value={formState.cpf}
                            onChange={(e) => {
                                const formattedCPF = formatCPF(e.target.value);
                                setFormState({ ...formState, cpf: formattedCPF });
                            }}
                            onBlur={handleBlur}
                            error={cpfError}
                            helperText={cpfError ? 'CPF inválido' : ''}
                            sx={textFieldStyles}
                            inputProps={{ maxLength: 14 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="Telefone"
                            variant="outlined"
                            fullWidth
                            name="telefone"
                            value={formatTelefone(formState.telefone)}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            error={telefoneError}
                            helperText={telefoneError ? 'Telefone inválido' : ''}
                            sx={textFieldStyles}
                            inputProps={{ maxLength: 15 }}
                        />

                    </Grid>
                </Grid>
                <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>Dados de Acesso</Typography>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="Email"
                            fullWidth
                            variant="outlined"
                            name="emailAcesso"
                            value={formState.emailAcesso}
                            onChange={handleFormState}
                            error={emailAcessoError}
                            helperText={emailAcessoError && 'Email inválido'}
                            disabled={usarMesmoEmail}
                            sx={textFieldStyles}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={usarMesmoEmail}
                                    onChange={(e) => {
                                        setUsarMesmoEmail(e.target.checked);
                                        setFormState({
                                            ...formState,
                                            emailAcesso: e.target.checked ? formState.emailPessoal : formState.emailAcesso,
                                        });
                                    }}
                                    color="primary"
                                />
                            }
                            sx={{ color: '#FF9F0D', '& .MuiSvgIcon-root': { color: '#FF9F0D' } }}
                            label="Usar o mesmo email para acesso"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            type={showPassword ? 'text' : 'password'}
                            label="Senha"
                            variant="outlined"
                            fullWidth
                            name="senha"
                            value={formState.senha}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            error={senhaError}
                            helperText={senhaError ? 'Senha deve ter pelo menos 6 caracteres' : ''}
                            sx={textFieldStyles}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            type={showPasswordConfirm ? 'text' : 'password'}
                            label="Confirmar Senha"
                            variant="outlined"
                            fullWidth
                            name="confirmarSenha"
                            value={formState.confirmarSenha}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            error={confirmarSenhaError}
                            helperText={confirmarSenhaError ? 'As senhas devem ser iguais' : ''}
                            sx={textFieldStyles}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={handleClickShowPasswordConfirm}
                                            onMouseDown={handleMouseDownPasswordConfirm}
                                            edge="end"
                                        >
                                            {showPasswordConfirm ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
                <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>Dados da Empresa</Typography>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label='CNPJ'
                            variant="outlined"
                            fullWidth
                            name="cnpj"
                            value={formatCNPJ(formState.cnpj)}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            error={cnpjError}
                            helperText={cnpjError ? 'CNPJ inválido' : ''}
                            sx={textFieldStyles}
                            inputProps={{ maxLength: 18 }}
                            InputProps={{
                                endAdornment: (
                                    <div>
                                        {loadingAutocompleteCnpj && (
                                            <CircularProgress sx={{ color: '#FF9F0D', ml: 1 }} size={18} />
                                        )}
                                    </ div>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="Razão Social"
                            variant="outlined"
                            fullWidth
                            name="razaoSocial"
                            value={formState.razaoSocial}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            error={razaoSocialError}
                            helperText={razaoSocialError ? 'Razão Social inválido' : ''}
                            sx={textFieldStyles}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <AutocompleteMap
                            sx={textFieldStyles}
                            variant="outlined"
                            fullWidth
                            value={formState.endereco}
                            formState={formState}
                            setFormState={setFormState}
                            handleCidadesChange={handleCidadesChange}
                            estados={estados}
                            setCidadePesquisa={setCidadePesquisa}
                            setPosition={setPosition}
                            setSemNumero={setSemNumero}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="CEP"
                            variant="outlined"
                            fullWidth
                            name="cep"
                            value={formatCEP(formState.cep)}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            error={cepError}
                            helperText={cepError ? 'CEP inválido' : ''}
                            sx={textFieldStyles}
                            inputProps={{ maxLength: 9 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Grid container spacing={1} direction="row">
                            <Grid item xs={6}>
                                <TextField
                                    label="Número"
                                    variant="outlined"
                                    fullWidth
                                    disabled={semNumero}
                                    name="numero"
                                    value={formState.numero}
                                    onChange={handleFormState}
                                    onBlur={handleBlur}
                                    error={numeroError && !semNumero}
                                    helperText={(numeroError && !semNumero) ? 'Número inválido' : ''}
                                    sx={textFieldStyles}
                                />
                            </Grid>
                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                <Grid container direction='row' wrap='nowrap' alignItems='center' sx={{ maxWidth: 'fit-content', width: '100%', pt: '.5rem' }}>
                                    <Checkbox
                                        checked={semNumero}
                                        onChange={handleSemNumeroChange}
                                        color="primary"
                                        icon={<RadioButtonUnchecked color="primary" sx={{ color: '#a9a9a9' }} />}
                                        checkedIcon={<CheckCircle sx={{ color: '#a6a6a6' }} />}
                                        id='semNumero'
                                    />
                                    <InputLabel
                                        sx={{ color: '#a9a9a9', whiteSpace: 'nowrap', fontSize: '0.9rem', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                        htmlFor="semNumero">
                                        Sem número
                                    </InputLabel>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            label="Complemento"
                            variant="outlined"
                            fullWidth
                            name="complemento"
                            value={formState.complemento}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            sx={textFieldStyles}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            label="Ponto Referência"
                            variant="outlined"
                            fullWidth
                            name="pontoReferencia"
                            value={formState.pontoReferencia}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            sx={selectStyles}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            label="Bairro"
                            variant="outlined"
                            fullWidth
                            name="bairro"
                            value={formState.bairro}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            error={bairroError}
                            helperText={bairroError ? 'Bairro inválido' : ''}
                            sx={selectStyles}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl sx={selectStyles}>
                            <InputLabel id="labelEstado">Estado</InputLabel>
                            <Select
                                labelId="labelEstado"
                                label="Estado"
                                variant="outlined"
                                fullWidth
                                name="estado"
                                value={formState.estado}
                                onChange={handleEstadoChange}
                                error={!!estadoError}
                            >
                                <MenuItem value="" disabled>Selecione um estado</MenuItem>
                                {estados.map((estado) => (
                                    <MenuItem key={estado.estadoNome} value={estado.estadoID}>
                                        {estado.estadoNome}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl sx={selectStyles}>
                            <InputLabel id="labelCidade">Cidade</InputLabel>
                            <Select
                                labelId="labelCidade"
                                label='cidade'
                                variant="outlined"
                                fullWidth
                                name="cidade"
                                value={formState.cidade}
                                onChange={handleFormState}
                                error={cidadeError}
                            >
                                <MenuItem value="" disabled>Selecione uma cidade</MenuItem>
                                {arrayCidades.length > 0 ? arrayCidades?.map((cidade) => (
                                    <MenuItem key={cidade.cidadeID} value={cidade.cidadeID}>
                                        {cidade.cidadeNome}
                                    </MenuItem>
                                )) : <MenuItem value={formState.cidade} key={formState.cidade}>{formState.cidade}</MenuItem>}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={24}>
                        <MapComponent position={position} setPosition={setPosition} />
                    </Grid>
                </Grid>
                <Grid container justifyContent={'center'} sx={{ mt: 2 }} >
                    <Grid item xs={12} sm={6} md={4}>
                        <ButtonPick
                            text={'Próximo'}
                            disabled={!prosseguir}
                            onClick={() => {
                                handleSubmit();
                                navigate('/pagamento')
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Container >
    );
}

export default Cadastro;
